<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ this.questions.title }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("AccountQacenter.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row v-for="(item, index) in this.questions.accounts_qacenter_answers" :key="index">
              <v-col cols="12" class="text-left" v-if="item.user_flag != 4">
                <div>{{ item.user_info }}  {{ item.created }}</div>
                <div class="account_qacenter_well request-left">
                  {{ item.text }}
                  <v-card
                          v-if="item.img_path && item.img_path.length > 0"
                          style="width: 240px;margin: auto"
                  >
                    <v-carousel hide-delimiters cycle height="200">
                      <v-carousel-item
                              v-for="(imgItem, imgIndex) in item.img_path"
                              :key="imgIndex"
                              :src="imgItem"
                              @click.stop="$showFullscreenImages(item.img_path, imgIndex)"
                      >
                      </v-carousel-item>
                    </v-carousel>
                  </v-card>
                </div>
              </v-col>
              <v-col cols="12"  class="text-right" v-else-if="item.user_flag == 4">
                <div>{{ item.created }}  {{ item.user_info }}</div>
                <div class="account_qacenter_well request-right">
                  {{ item.text }}
                  <v-card
                          v-if="item.img_path && item.img_path.length > 0"
                          style="width: 240px;margin: auto"
                  >
                    <v-carousel hide-delimiters cycle height="200">
                      <v-carousel-item
                              v-for="(imgItem, imgIndex) in item.img_path"
                              :key="imgIndex"
                              :src="imgItem"
                              @click.stop="$showFullscreenImages(item.img_path, imgIndex)"
                      >
                      </v-carousel-item>
                    </v-carousel>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- 回复 -->
      <v-card class="page-card" v-if="questions.status != 0">
        <v-card-title>
          {{ $t("AccountQacenter.Fields.answer") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-8 pb-12">
          <ValidationObserver ref="observer">
            <v-row align="center">
              <v-col cols="12">
                <ValidationProvider
                        v-slot="{ errors }"
                        :name="$t('AccountQacenter.Fields.answer')"
                        rules="required"
                >
                  <v-textarea
                          outlined
                          :placeholder="$t('AccountQacenter.tips')"
                          :error-messages="errors"
                          v-model="text"
                  >
                    <template v-slot:message="{ key, message }">
                      <div :class="key == 0 ? 'danger--text' : ''">
                        {{ message }}
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                <v-card
                        v-if="qa_album && qa_album.length > 0"
                        style="width: 240px;"
                >
                  <v-carousel hide-delimiters cycle height="200">
                    <v-carousel-item
                            v-for="(item, i) in qa_album"
                            :key="i"
                            :src="item"
                            @click.stop="$showFullscreenImages(qa_album, i)"
                    >
                      <v-tooltip right v-if="item">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="secondary"
                                  class="pa-2 float-right"
                                  @click.stop="removeFromImages(i)"
                          >
                            fa-times
                          </v-icon>
                        </template>
                        <span> {{ $t("Material.delImg") }}</span>
                      </v-tooltip>
                    </v-carousel-item>
                  </v-carousel>
                </v-card>
                <v-file-input
                        ref="qa_imgs_file"
                        show-size
                        counter
                        small-chips
                        multiple
                        suffix
                        prepend-icon="fa-camera"
                        accept="image/png, image/jpeg"
                        persistent-hint
                        :placeholder="$t('Material.imgsPlaceholder')"
                        :rules="imgsRules"
                        v-model="qa_imgs_file"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-card" v-else>
        <v-card-title>
          {{ $t("AccountQacenter.doneTips") }}
        </v-card-title>
      </v-card>

      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                      outlined
                      color="secondary"
                      class="elevation-1"
                      block
                      @click="
                      $emit('input', null);
                      $emit('mode', null);
                    "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("AccountQacenter.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col
                    cols="12"
            >
              <v-btn
                      color="success"
                      block
                      :disabled="loading"
                      @click="submit()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("AccountQacenter.Fields.submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider  } from "vee-validate";
import AccountQacenter from "@/api/account_qacenter";
import Files from "@/api/files"
import Vue from "vue";

export default {
  name: "AccountQacenterDetail",

  props: ["value", "accountUserName", "accountInfo"],

  components: {
    ValidationObserver,
    ValidationProvider
  },

  computed: {
    baseUrl() {
      return Vue.prototype.$BaseURL
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    text:'',
    qa_album: [],
    qa_imgs_file: [],
    questions: [],
    imgsRules: [
      (value) =>
              !value ||
              value.filter((v) => v.size >= 5000000).length == 0 ||
              i18n.t("Material.Import.imgsHint"),
    ],
  }),

  methods: {
    removeFromImages(i) {
      this.qa_album.splice(i, 1);
      this.qa_imgs_file.splice(i, 1);
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
              async function (result) {
                if (result) {
                  let img_path = [];
                  let answerSaveData = {
                    question_id: this.questions.id,
                    enterprise_id: this.questions.enterprise_id,
                    account_id: this.questions.account_id,
                    text: this.text,
                    img_path: img_path,
                    account_user_name: this.accountUserName,
                    user_id: this.questions.user_id
                  };
                  if (this.qa_imgs_file.length > 0 ) {
                    let imgResponse = await Files.imagesUpload(this.qa_imgs_file, false, "accounts_qa");
                    if (imgResponse.data.status.isOK()) {
                      imgResponse.data.data.forEach((column) => {
                        img_path.push(column.img_name)
                      })
                      AccountQacenter.newAnswerSave(answerSaveData)
                              .then((response) => {
                                if (response.data.status.isOK()) {
                                  this.$emit("mode", null);
                                  this.$emit("input", null);
                                }
                              })
                    }
                  }else {
                    AccountQacenter.newAnswerSave(answerSaveData)
                    .then((response) => {
                      if (response.data.status.isOK()) {
                        this.$emit("mode", null);
                        this.$emit("input", null);
                      }
                    })
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                } else {
                  this.$store.dispatch("fullscreenLoadingStop");
                }
              }.bind(this)
      );
    },
    resetDetails() {
      this.text = '';
      this.qa_album = [];
      this.qa_imgs_file = [];
    }
  },
  watch: {
    value: {
      immediate: false, //初始赋值不调用
      handler() {
        if (this.value && this.value.id) {
          // 获取反馈回复
          AccountQacenter.fetch({question_id: this.value.id, account_id: this.accountInfo.account_id}).then((response) => {
            if (response.data.status.isOK()) {
              this.questions = response.data.question
              this.questions.accounts_qacenter_answers.forEach((column) => {
                if (column['img_path']) {
                  let img_array = column['img_path'].split(";");
                  column['img_path'] = [];
                  img_array.forEach((img_path) => {
                    column['img_path'].push(Vue.prototype.$BaseURL + 'upload/accounts_qa/' + img_path)
                  })
                }
              })
            }
          })
        }
        this.$scrollTop(); //返回顶部
        this.resetDetails(); //清除表单
        this.$refs.observer.reset(); //清除表单验证错误
      },
    },
    qa_imgs_file: {
      handler() {
        if (this.qa_imgs_file) {
          this.qa_album = [];
          this.qa_imgs_file.forEach((img, i) => {
            var reader = new FileReader();
            reader.readAsDataURL(img);
            let that = this;
            reader.onload = function () {
              that.qa_album.splice(i, 0, this.result);
            };
          });
        } else {
          this.qa_album = [];
        }
      },
    },
  },
};
</script>